import { isUndefined } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { RadioRow } from '../../../../shared/radio/RadioRow';
import styles from './TableInstanceFilters.module.scss';

interface ToggleFilterProps {
    updateFilter: (value: boolean | undefined) => void;
    filter: boolean | undefined;
    testId: string;
    labels?: [string, string];
    marginBottom?: string;
}

export const ToggleFilter: React.FC<ToggleFilterProps> = ({ updateFilter, filter, testId, labels = ['Selected', 'Not Selected'], marginBottom }) => {
    const onChange = useCallback((id: string) => {
        if (!isUndefined(filter) && ((filter && id === 'true') || (!filter && id === 'false'))) {
            updateFilter(undefined);
        } else {
            updateFilter(id === 'true');
        }
    }, [updateFilter, filter]);

    const toggleOptions = useMemo(() => [
        { id: 'true', label: labels[0], isSelected: !isUndefined(filter) && filter },
        { id: 'false', label: labels[1], isSelected: !isUndefined(filter) && !filter },
    ], [filter, labels]);

    return (
        <div className={styles.toggleFilterWrapper} data-testid={`${testId}-toggle-filter`} style={{ marginBottom }}>
            <RadioRow onChange={onChange} options={toggleOptions} />
        </div>
    );
};
